import { render, staticRenderFns } from "./FloatingButtons.vue?vue&type=template&id=6e05e175&"
import script from "./FloatingButtons.vue?vue&type=script&lang=js&"
export * from "./FloatingButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports